import type { ReactNode } from "react";

export function InfoBlock(props: {
  name: string;
  eyebrow: ReactNode;
  title: ReactNode;
  body: ReactNode;
  meta?: ReactNode;
  children?: ReactNode;
  className?: string;
}) {
  return (
    <article
      className={["info-block", props.className].filter(Boolean).join(" ")}
      data-info-block={props.name}
    >
      <header className="info-block-header">
        <div>
          <p className="info-block-eyebrow">{props.eyebrow}</p>
          <h2 className="info-block-title">{props.title}</h2>
        </div>
        {props.meta && <div className="info-block-meta">{props.meta}</div>}
      </header>
      <div className="info-block-body">{props.body}</div>
      {props.children && <div className="info-block-content">{props.children}</div>}
    </article>
  );
}
